var StorageHandler = /** @class */ (function () {
    function StorageHandler() {
    }
    StorageHandler.setItem = function (key, value) {
        try {
            var serializedValue = JSON.stringify(value);
            localStorage.setItem(key, serializedValue);
        }
        catch (e) {
            console.error('Failed to serialize the value for storage.', e);
        }
    };
    StorageHandler.getItem = function (key) {
        var serializedValue = localStorage.getItem(key);
        if (serializedValue === null) {
            return null;
        }
        try {
            return JSON.parse(serializedValue);
        }
        catch (e) {
            console.error('Failed to parse the stored value.', e);
            StorageHandler.removeItem(key);
            return null;
        }
    };
    StorageHandler.removeItem = function (key) {
        localStorage.removeItem(key);
    };
    return StorageHandler;
}());

export { StorageHandler as default };
